import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3" }
const _hoisted_2 = { class: "p-25" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4" }
const _hoisted_4 = { class: "dropdown select-dropdown" }
const _hoisted_5 = {
  class: "dropdown-toggle border text-body rounded-2 bg-gray-100",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_6 = { class: "dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3" }
const _hoisted_7 = { style: {"margin":"-20px 0 -25px -15px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "mb-0" }, "Revenue Goal Progress", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", _hoisted_5, _toDisplayString(_ctx.selectedPeriod), 1),
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item text-secondary py-2 px-3",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateChartData('Daily')))
              }, " Daily ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item text-secondary py-2 px-3",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateChartData('Weekly')))
              }, " Weekly ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item text-secondary py-2 px-3",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateChartData('Monthly')))
              }, " Monthly ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item text-secondary py-2 px-3",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateChartData('Yearly')))
              }, " Yearly ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "line",
              height: "399",
              options: _ctx.orderSummary,
              series: _ctx.summary
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}